import { Link } from "react-scroll";

/*--------------------
* Intrested Section
----------------------*/

export default function Intrested() {
  return (
    <section className="py-10 bg-slate-900">
      <div className="container">
        <div className="grid grid-cols-12 gap-5 items-center">
          <div className="col-span-12 lg:col-span-8 md:col-span-7 text-center md:text-left">
            <h3 className="text-[25px] md:text-[25px] lg:text-[25px] m-0 text-white font-[500]">
              경영전략 전문가로 거듭나길 원하신다면
            </h3>
          </div>
          <div className="col-span-12 lg:col-span-4 md:col-span-5 text-center text-md-end">
            <Link className="px-btn px-btn-theme2" to="contactus">
              서비스 이용/제휴 문의
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
